import { useState } from 'react';
import { faqs } from '@/mocks/comic';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
            <span className="h-px w-8 bg-primary-500" />
            常见问题
            <span className="h-px w-8 bg-primary-500" />
          </span>
          <h2 className="mt-4 font-heading text-3xl font-black text-foreground-900 md:text-4xl">
            你可能想知道
          </h2>
        </div>

        <div className="mt-10 flex flex-col gap-4">
          {faqs.map((f, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200/70"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                  aria-expanded={isOpen}
                >
                  <h3 className="font-heading text-base font-bold text-foreground-900 md:text-lg">{f.q}</h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-transform duration-300 ${
                      isOpen ? 'rotate-45 bg-primary-500 text-background-50' : ''
                    }`}
                  >
                    <i className="ri-add-line text-base" />
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700 md:px-6 md:pb-6">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}